/** Route segments, kept free of page imports so feature code can link to pages without import cycles. */
export const WallFormingBaseRoute = 'forming';
export const PlanStartRoute = 'plans';
export const IfcWallEditorRoute = 'ifc-editor';

export const getIfcWallEditorPath = (ifcModelId: string) => `/${IfcWallEditorRoute}/${ifcModelId}`;
